export var Device = {
    getRatio: function () {
        return Device.getScreenSize().width / 375;
    },
    getScreenSize: function () {
        if (typeof window === 'undefined' || typeof window.innerHeight === 'undefined') {
            return {
                width: 375,
                height: 565,
            };
        }
        return {
            width: Math.min(window.innerWidth, 450),
            height: window.innerHeight,
        };
    },
    getVirtualSize: function () {
        var size = Device.getScreenSize();
        return {
            width: 375,
            height: size.height / size.width * 375,
        };
    },
    requestDeviceOrientationPermission: function (deviceOrientationEvent) {
        var isListened = false;
        var isDisposed = false;
        var request = new Promise(function (resolve) {
            if (typeof window === 'undefined' || typeof window.DeviceOrientationEvent === 'undefined') {
                resolve(false);
                return function () { };
            }
            if (typeof window.DeviceOrientationEvent.requestPermission === 'undefined') {
                resolve(true);
                window.addEventListener('deviceorientation', deviceOrientationEvent, true);
                return function () {
                    window.removeEventListener('deviceorientation', deviceOrientationEvent, true);
                };
            }
            window.DeviceOrientationEvent.requestPermission()
                .then(function (state) {
                if (state === 'granted' && !isDisposed) {
                    resolve(true);
                    // 如果提前执行了clear函数，这里的isDisposed会变成true
                    // 起到阻止监听动作的效果
                    window.addEventListener('deviceorientation', deviceOrientationEvent, true);
                    isListened = true;
                    return;
                }
                resolve(false);
            })
                .catch(function (err) {
                console.log("\u6388\u6743\u5931\u8D25 ".concat(err.toString()));
                resolve(false);
            });
        });
        var dispose = function () {
            isDisposed = true;
            if (isListened === false) {
                return;
            }
            window.removeEventListener('deviceorientation', deviceOrientationEvent, true);
        };
        return {
            request: request,
            dispose: dispose,
        };
    },
};
